import { useEffect } from 'react';
import { Spinner } from '@ds';
import { ResourceAvatar } from '@ui';
import { LogisticsLegResourceType } from '@/api/apis/route';
import { useOcsConsoleByIdQuery } from '@/queries/ocs-consoles';
import { ResourceCard, ResourceCardText, ResourceWarningTooltip } from './ResourceCard';
import { useSuggestedRouteValidationContext } from './SuggestedRouteValidationContext';

const FALLBACK_HUB_LABEL = 'HUB';

type RouteResourceDeviceProps = {
  suggestedRouteId: string;
  resource: LogisticsLegResourceType;
};

export const RouteResourceDevice = ({ suggestedRouteId, resource }: RouteResourceDeviceProps) => {
  const { setOCSResource } = useSuggestedRouteValidationContext();
  const { data, isLoading } = useOcsConsoleByIdQuery(resource.resourceId);

  const hasNoDevice = !isLoading && !data;

  useEffect(() => {
    setOCSResource(suggestedRouteId, !hasNoDevice);
  }, [suggestedRouteId, hasNoDevice, setOCSResource]);

  return (
    <ResourceCard hasWarning={hasNoDevice} className="justify-center">
      {isLoading && <Spinner size="md" />}
      {hasNoDevice && (
        <div className="flex gap-1 items-center">
          <span className="text-s-sb text-black truncate italic">OCS Device not found.</span>
          <ResourceWarningTooltip
            content="This OCS Device is no longer available for reservation."
            className="self-end"
          />
        </div>
      )}
      {!isLoading && data && (
        <div className="flex gap-2 grow">
          <ResourceAvatar
            type="device"
            size="md"
            radius="md"
            organ={data.organType}
            src={data.logoPath}
            name={data.fullSerialNumber}
          />
          <ResourceCardText title={data.fullSerialNumber} subTitle={data.hub?.code || FALLBACK_HUB_LABEL} />
        </div>
      )}
    </ResourceCard>
  );
};
